module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_06-614a9c34384afae48adce38109e2fc6c.svg";